import { matchColor, pick, type LayerStyle } from "./types";

// Contours are lines (DNL 65, 70, 75), so they are drawn as lines, not fills.
const DNL65 = "#aa711d";
const DNL70 = "#d9480f";
const DNL75 = "#c0504d";

const style: LayerStyle = {
  id: "aus-noise",
  minzoom: 9,
  maxzoom: 14,
  layers(source) {
    return [
      {
        id: `${this.id}:line`,
        type: "line",
        source,
        "source-layer": this.id,
        minzoom: this.minzoom,
        paint: {
          // The level may arrive as a number or a string; to-number lets numeric labels match both.
          "line-color": matchColor(["to-number", ["get", "DAY_NIGHT_SOUND_LEVEL"], 0], [[65, DNL65], [70, DNL70], [75, DNL75]]),
          "line-width": ["interpolate", ["linear"], ["zoom"], 9, 1.5, 14, 3],
        },
      },
    ];
  },
  legend: [
    { label: "65 dB DNL contour", color: DNL65 },
    { label: "70 dB DNL contour", color: DNL70 },
    { label: "75 dB DNL contour", color: DNL75 },
  ],
  describe: (p) => pick(p, [["DAY_NIGHT_SOUND_LEVEL", "Day-night sound level (dB DNL)"]]),
};

export default style;
